import { useCallback } from 'react'
import { UseData } from './useData'

export function useHandlers(data: UseData) {
  const { open, setOpen } = data

  const onClose = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  const onOpen = useCallback(() => {
    setOpen(true)
  }, [setOpen])

  return {
    open,
    onClose,
    onOpen,
  }
}
